import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from './avatar.component';
import { BackgroundImageModule } from '../background-image/public-api';

@NgModule({
  declarations: [AvatarComponent],
  imports: [CommonModule, BackgroundImageModule],
  exports: [AvatarComponent],
})
export class AvatarModule {}
